import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    UPDATE_SHIFT_TYPE: {
        url: "update/shift-day-type",
        method: "post",
    },

    UPDATE_WTF_VALUE: {
        url: "verzoeken/scherm/updateWtfValue",
        method: "post",
    },

    UPDATE_MEMO: {
        url: "verzoeken/scherm/updateMemo",
        method: "post",
    },

    UPDATE_USER_EGYM_STATUS: {
        url: "verzoeken/updateEgymStatus",
        method: "post",
    },

    REMOVE_GYM: {
        url: "verzoeken/deleteEgym",
        method: "post",
    },

    SAVE_EVALUATION: {
        url: "verzoeken/save-evaluation",
        method: "post",
    },

  DELETE_LONG_CONTRACT_BY_ID: (id) => ({
    url: `long-contract/delete/${id}`,
    method: "get",
}),


    GET_LOGS_DATA: (id, type) => ({
        url: `verzoeken/logs/${id}?type=${type}`,
        method: "get",
    }),

    GET_PART_DAYS_DATA: (id) => ({
        url: `verzoeken/part-of-days/${id}`,
        method: "get",
    }),

    GET_REQUEST_BY_ID: (id) => ({
        url: `verzoeken/scherm/${id}`,
        method: "get",
    }),

    UPDATE_DAY_PARTS: (substitutionId) => ({
        url: `requisition/${substitutionId}`,
        method: "patch",
    }),

    GET_REQUEST_LIST: {
        url: "verzoeken/scherm",
        method: "post",
    },
    CHECK_USER_EMAIL_LINK: (hash, userType) => ({
        url: `check-user-email-link?h=${hash}&u=${userType}`,
        method: "get",
    }),


};

// ===================== Hooks =====================

export const useUpdateShiftType = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_SHIFT_TYPE);

export const useUpdateWtfValue = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_WTF_VALUE);

export const useUpdateMemo = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_MEMO);

export const useUpdateUserEgymStatus = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_USER_EGYM_STATUS);

export const useRequestList = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_REQUEST_LIST);

export const useRemoveGym = () =>
    useApiFetcherSWR(API_ENDPOINT.REMOVE_GYM);

export const useSaveEvaluation = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_EVALUATION);

export const useDeleteLongContractById = (id) =>
    useApiFetcherSWR(
        id ? API_ENDPOINT.DELETE_LONG_CONTRACT_BY_ID(id) : null
    );

export const useLogsData = (id, logType) =>
    useApiFetcherSWR(
        id && logType ? API_ENDPOINT.GET_LOGS_DATA(id, logType) : null
    );
export const usePartDaysData = (activityLogId) =>
    useApiFetcherSWR(
        activityLogId ? API_ENDPOINT.GET_PART_DAYS_DATA(activityLogId) : null
    );

export const useRequestById = (substitutionId) => {

    return useApiFetcherSWR(
        substitutionId
            ? API_ENDPOINT.GET_REQUEST_BY_ID(substitutionId)
            : null
    );
};
export const useUpdateDayParts = (substitutionId) =>
    useApiFetcherSWR(
        API_ENDPOINT.UPDATE_DAY_PARTS(substitutionId)
    );

export const useEvaluationRequest = (hash, userType) =>
    useApiFetcherSWR(
        hash && userType
            ? ["evaluation-link", hash, userType]
            : null,
        () => API_ENDPOINT.CHECK_USER_EMAIL_LINK(hash, userType)
    )

